import { ToastBody } from './_ToastBody';
import 'react-toastify/dist/ReactToastify.css';
import { onPositionNative } from './_toastPosition';
import { toast, ToastContainer } from 'react-toastify';

/*
    🔥 TOAST — react-toastify

    Toastify envuelve el contenido en su propio div: por eso el CSS
    neutraliza su padding y fondo (ver AlertToast.css).

    ⚠️ Si el import del CSS falla, en v11 la ruta puede ser
       'react-toastify/ReactToastify.css' (sin /dist).
*/

export const AlertToastifyHost = ({ position }) => (
    <ToastContainer position={onPositionNative(position)} autoClose={4000} newestOnTop
        hideProgressBar closeButton={false} icon={false}
        className="LStudio__app_toast_container" toastClassName="LStudio__app_toast_wrap" />
);

export const onNotifyToastify = ({ type = 'info', title, text, autoClose }) => (

    toast(
        ({ closeToast }) => <ToastBody type={type} title={title} text={text} onClose={closeToast} />,
        { autoClose: autoClose || 4000 },
    )
);
